export default {
    companyList: [],
    infoDB: {},
    adminCompany: null
}
